import types from '../types'
import { getCleanPaxFromUrl } from 'tickets/utils/urlUtils'

const initialState = {
  pax: getCleanPaxFromUrl(),
  travelCards: [],
  areTravelCardsKnown: false,
}

const passengersReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.PASSENGER_OPTIONS_DATA_RECEIVED:
      return {
        ...state,
        travelCards: action.payload.discountCards,
        areTravelCardsKnown: true,
        pax: resetPaxTravelCards(state, action.payload.discountCards),
      }
    case types.PASSENGER_MINUS:
      return {
        ...state,
        pax: removePassenger(state, action.payload),
      }
    case types.PASSENGER_ADD:
      return {
        ...state,
        pax: addPassenger(state, action.payload),
      }
    case types.PASSENGER_REMOVE:
      return {
        ...state,
        pax: removeExactPassenger(state, action.payload),
      }
    case types.PASSENGER_UPDATE:
      return {
        ...state,
        pax: updatePassenger(state, action.payload),
      }
    case types.PAX_UPDATE:
      return {
        ...state,
        pax: action.payload,
      }
    default:
      return state
  }
}

const removePassenger = (state, type) => {
  // remove the most recently added passenger of that type
  const newPax = [...state.pax]
  for (let i = newPax.length - 1; i >= 0; i--) {
    const passenger = newPax[i]
    if (passenger.type === type) {
      newPax.splice(i, 1)
      break
    }
  }
  return newPax
}

const addPassenger = (state, passenger) => {
  const newPax = [...state.pax]
  newPax.push(passenger)
  return newPax
}

const removeExactPassenger = (state, passengerId) => {
  const newPax = [...state.pax]
  newPax.splice(passengerId, 1)
  return newPax
}

const updatePassenger = (state, { passengerId, passenger }) => {
  const newPax = [...state.pax]
  newPax[passengerId] = passenger
  return newPax
}

const resetPaxTravelCards = (state, travelCardOptions) => {
  const newPax = [...state.pax]
  const travelCardOptionIds = travelCardOptions.map((card) => card.id)
  return newPax.map((passenger) => {
    if (!travelCardOptionIds.includes(passenger.travelCard)) {
      passenger.travelCard = null
    }
    return passenger
  })
}


export default passengersReducer
